// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    font-family: 'Inter', serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    font-weight: 400;
    color: #393f52;
    font-optical-sizing: auto;
}

/* change scroll browser */
.custom-scroll-bar::-webkit-scrollbar {
    width: 5px;
}

.custom-scroll-bar::-webkit-scrollbar-track {
    background-color: rgba(25, 147, 147, 0.1);
    border-radius: 10px;
}

.custom-scroll-bar::-webkit-scrollbar-thumb {
    background-color: rgb(175, 130, 253);
    border-radius: 10px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
}

/* custom tooltip */
.ant-tooltip .ant-tooltip-arrow:before {
    background-color: var(--tc-system-info-50);
}

/* ant-popover .ant-popover-content */
.ant-popover .ant-popover-content {
    min-width: 150px;
}

.body-edit-table-drawer {
    padding: 12px !important;
}

.body-card-services-drawer {
    padding: 0 !important;
}

.notification-dropdown {
    top: 65px !important;
}

.notification-dropdown .ant-dropdown-menu {
    border-radius: 0 0 12px 12px !important;
    box-shadow: none !important;
}

.ant-picker-dropdown .ant-picker-panel-container {
    display: inline-flex;
    animation: none;
    flex-wrap: nowrap;
    direction: ltr;
}

/* ant-picker */
.ant-picker-panel-container {
    .ant-picker-presets {
        min-height: 25rem !important;
    }

    @media (max-width: 800px) {
        overflow: scroll !important;
        height: 400px;

        .ant-picker-panel-layout {
            flex-direction: column !important;
        }
    }
}

.ant-picker-panel-layout {
    flex-direction: column !important;
}

.ant-picker-panel-layout .ant-picker-presets {
    max-width: 100% !important;
    min-height: 10rem !important;
}

.ant-picker-panel-container .ant-picker-panel-layout .ant-picker-presets {
    max-width: 100% !important;
    min-height: 5rem !important;
}

/* Custom modal css */
.line-items-modal .ant-modal {
    max-height: calc(100vh - 20px);
    width: 100vw !important;
}
.line-items-modal .ant-modal .ant-modal-content {
    height: calc(100vh - 20px);
}

.line-items-modal .ant-modal .ant-modal-content .ant-table-content {
    overflow: auto !important;
    max-height: calc(100vh - 150px);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,2BAA2B;IAC3B,mCAAmC;IACnC,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,0BAA0B;AAC1B;IACI,UAAU;AACd;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA,YAAY;AACZ;IACI,0BAA0B;AAC9B;;AAEA,mBAAmB;AACnB;IACI,0CAA0C;AAC9C;;AAEA,qCAAqC;AACrC;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;QAC3B,aAAa;;QAEb;YACI,iCAAiC;QACrC;IACJ;AACJ;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,qBAAqB;AACrB;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC","sourcesContent":["body {\n    margin: 0;\n    font-family: 'Inter', serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: 16px;\n    font-weight: 400;\n    color: #393f52;\n    font-optical-sizing: auto;\n}\n\n/* change scroll browser */\n.custom-scroll-bar::-webkit-scrollbar {\n    width: 5px;\n}\n\n.custom-scroll-bar::-webkit-scrollbar-track {\n    background-color: rgba(25, 147, 147, 0.1);\n    border-radius: 10px;\n}\n\n.custom-scroll-bar::-webkit-scrollbar-thumb {\n    background-color: rgb(175, 130, 253);\n    border-radius: 10px;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Firefox */\ninput[type='number'] {\n    -moz-appearance: textfield;\n}\n\n/* custom tooltip */\n.ant-tooltip .ant-tooltip-arrow:before {\n    background-color: var(--tc-system-info-50);\n}\n\n/* ant-popover .ant-popover-content */\n.ant-popover .ant-popover-content {\n    min-width: 150px;\n}\n\n.body-edit-table-drawer {\n    padding: 12px !important;\n}\n\n.body-card-services-drawer {\n    padding: 0 !important;\n}\n\n.notification-dropdown {\n    top: 65px !important;\n}\n\n.notification-dropdown .ant-dropdown-menu {\n    border-radius: 0 0 12px 12px !important;\n    box-shadow: none !important;\n}\n\n.ant-picker-dropdown .ant-picker-panel-container {\n    display: inline-flex;\n    animation: none;\n    flex-wrap: nowrap;\n    direction: ltr;\n}\n\n/* ant-picker */\n.ant-picker-panel-container {\n    .ant-picker-presets {\n        min-height: 25rem !important;\n    }\n\n    @media (max-width: 800px) {\n        overflow: scroll !important;\n        height: 400px;\n\n        .ant-picker-panel-layout {\n            flex-direction: column !important;\n        }\n    }\n}\n\n.ant-picker-panel-layout {\n    flex-direction: column !important;\n}\n\n.ant-picker-panel-layout .ant-picker-presets {\n    max-width: 100% !important;\n    min-height: 10rem !important;\n}\n\n.ant-picker-panel-container .ant-picker-panel-layout .ant-picker-presets {\n    max-width: 100% !important;\n    min-height: 5rem !important;\n}\n\n/* Custom modal css */\n.line-items-modal .ant-modal {\n    max-height: calc(100vh - 20px);\n    width: 100vw !important;\n}\n.line-items-modal .ant-modal .ant-modal-content {\n    height: calc(100vh - 20px);\n}\n\n.line-items-modal .ant-modal .ant-modal-content .ant-table-content {\n    overflow: auto !important;\n    max-height: calc(100vh - 150px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
